module.exports = __webpack_public_path__ + "img/hr-red-croton-16.4b1b8dd6.png";